import { render, staticRenderFns } from "./TrackingEmails.vue?vue&type=template&id=208618a2&scoped=true&"
import script from "./TrackingEmails.vue?vue&type=script&lang=js&"
export * from "./TrackingEmails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208618a2",
  null
  
)

export default component.exports
import QPage from 'quasar/src/components/page/QPage.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QPage});
